import { FormControlLabel, Radio, RadioGroup, Stack, Typography } from '@mui/material'


const ZRadioGroup = ({ id, row = true, direction = 'row', title = '', titleId, disabled = false, values = [], defaultValue, selectedValue, onChange }) => {
  return (
    <Stack
      direction={direction}
      spacing={2}
      justifyContent="space-between"
    >
      <Typography id={titleId} variant="h4">{title}</Typography>
      <RadioGroup
        id={id}
        row={row}
        name={id}
        defaultValue={defaultValue}
        aria-labelledby={titleId}
      >
        {values.map(({ id, label, value }, index) =>
          <FormControlLabel
            key={`form-control-label-${index}`}
            value={value}
            disabled={disabled}
            control={
              <Radio
                id={id}
                onChange={onChange}
                checked={value === selectedValue}
                disabled={disabled}
              />
            }
            label={label}
          />
        )}
      </RadioGroup>
    </Stack>
  )
}

export default ZRadioGroup